import { Components, Theme } from "@mui/material";
// components
import { MuiCssBaseline } from "./MuiCssBaseline";
import { MuiButton } from "./MuiButton";
import { MuiTextField } from "./MuiTextField";
import { MuiSelect } from "./MuiSelect";
import { MuiAppBar } from "./MuiAppBar";
import { MuiDivider } from "./MuiDivider";
import { MuiAutocomplete } from "./MuiAutocomplete";
import { MuiMenu, MuiMenuItem } from "./MuiMenu";
import { MuiTablePagination, MuiTableRow, MuiTableCell } from "./MuiTable";
import { MuiCard } from "./MuiCard";
import { MuiRadio } from "./MuiRadio";
import { MuiChip } from "theme/component-overrides/MuiChip";

export const components: Components<Omit<Theme, "components">> = {
  MuiAppBar,
  MuiAutocomplete,
  MuiButton,
  MuiCard,
  MuiChip,
  MuiCssBaseline,
  MuiDivider,
  MuiMenu,
  MuiMenuItem,
  MuiSelect,
  MuiTableCell,
  MuiTablePagination,
  MuiTableRow,
  MuiTextField,
  MuiRadio,
  MuiDialog: {
    styleOverrides: {
      paper: ({ theme }) => ({
        borderRadius: 20,
        boxShadow:
          theme.palette.mode === "dark"
            ? "0 24px 48px rgba(0,0,0,0.4)"
            : "0 24px 48px rgba(0,0,0,0.12)",
      }),
    },
  },
  MuiDrawer: {
    styleOverrides: {
      paper: ({ theme }) => ({
        borderRight: "none",
        boxShadow:
          theme.palette.mode === "dark"
            ? "4px 0 24px rgba(0,0,0,0.3)"
            : "4px 0 24px rgba(0,0,0,0.06)",
      }),
    },
  },
  MuiLinearProgress: {
    styleOverrides: {
      root: {
        borderRadius: 6,
        height: 6,
      },
      bar: {
        borderRadius: 6,
      },
    },
  },
  MuiSkeleton: {
    styleOverrides: {
      root: {
        borderRadius: 12,
      },
      rectangular: {
        borderRadius: 14,
      },
    },
  },
  MuiAlert: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: 12,
        fontWeight: 500,
      }),
      standardWarning: ({ theme }) => ({
        backgroundColor: `${theme.palette.warning.main}15`,
        color: theme.palette.warning.dark,
      }),
      standardError: ({ theme }) => ({
        backgroundColor: `${theme.palette.error.main}15`,
        color: theme.palette.error.dark,
      }),
      standardSuccess: ({ theme }) => ({
        backgroundColor: `${theme.palette.success.main}15`,
        color: theme.palette.success.dark,
      }),
      standardInfo: ({ theme }) => ({
        backgroundColor: `${theme.palette.info.main}15`,
        color: theme.palette.info.dark,
      }),
    },
  },
  MuiBadge: {
    styleOverrides: {
      standard: {
        fontWeight: 700,
        fontSize: "0.6875rem",
      },
    },
  },
  MuiSwitch: {
    styleOverrides: {
      root: {
        width: 44,
        height: 24,
        padding: 0,
      },
      switchBase: ({ theme }) => ({
        padding: 3,
        "&.Mui-checked": {
          transform: "translateX(20px)",
          "& + .MuiSwitch-track": {
            opacity: 1,
            backgroundColor: theme.palette.primary.main,
          },
        },
      }),
      thumb: {
        width: 18,
        height: 18,
        boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
      },
      track: ({ theme }) => ({
        borderRadius: 12,
        opacity: 1,
        backgroundColor: theme.palette.grey[300],
      }),
    },
  },
  MuiTooltip: {
    styleOverrides: {
      tooltip: ({ theme }) => ({
        borderRadius: 8,
        fontSize: "0.75rem",
        fontWeight: 500,
        padding: "6px 12px",
        backgroundColor:
          theme.palette.mode === "dark"
            ? theme.palette.grey[700]
            : theme.palette.grey[800],
      }),
    },
  },
};
